<script setup lang="ts">
import "@maersk-global/mds-components-core-input-date";
import { defineProps, defineEmits } from "vue";
// Props
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  valueFrom: {
    type: String,
    required: true
  },
  valueTo: {
    type: String,
    required: true
  }
});

// Emit events
defineEmits(["from-date", "to-date"]);
</script>

<template>
  <div class="date-picker-filter">
    <div>{{ props.label }}</div>
    <div class="date-range arrival-departure">
      <mc-input-date
        :value="props.valueFrom"
        format="DD-MM-YYYY"
        placeholder="DD-MM-YYYY"
        label=""
        fit="small"
        @inputdateselected="$emit('from-date', $event)"
      >
      </mc-input-date>
      <div class="center-text">-</div>
      <mc-input-date
        :value="props.valueTo"
        :activedate="props.valueFrom"
        format="DD-MM-YYYY"
        placeholder="DD-MM-YYYY"
        label=""
        fit="small"
        @inputdateselected="$emit('to-date', $event)"
      >
      </mc-input-date>
    </div>
  </div>
</template>
